import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/CSSPlugin'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		gsap.registerPlugin(CSSPlugin)

		toggleNavMenu()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function toggleNavMenu() {
	$(window).click(() => {
		if ($('.nav-indicator').hasClass('show')) {
			$('.nav-indicator').removeClass('show')
			$('.car-filters__dropdown-list').removeClass('active')
		}
	})

	$('.multiSel').click((e) => {
		e.stopPropagation()
		$('.nav-indicator').toggleClass('show')
		$('.car-filters__dropdown-list').toggleClass('active')
	})
}
